"use strict";

exports.__esModule = true;
exports.AiCreateButton = AiCreateButton;
exports.uniqueId = uniqueId;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactRouterDom = require("react-router-dom");
var _featureFlags = require("../../../featureFlags");
var _HasAccess = require("../../Auth/Access/HasAccess");
var _Translator = require("../../Core/Translator");
var _DashboardCollectionContext = require("../../Dashboard/DashboardCollection/DashboardCollectionContext");
var _ReportCollectionContext = require("../../Report/ReportCollection/ReportCollectionContext");
var _System = require("../../../System");
var _AiPromptDialog = require("./AiPromptDialog");
var _excluded = ["kind"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var KINDS = {
  dashboard: {
    permission: "CREATE_DASHBOARDS",
    screen: "Dashboard",
    context: _DashboardCollectionContext.DashboardCollectionContext
  },
  report: {
    permission: "CREATE_REPORTS",
    screen: "Report",
    context: _ReportCollectionContext.ReportCollectionContext
  }
};

// The service derives the id from the name; a second document with the same
// name gets a numbered id, the way a person renaming by hand would.
function uniqueId(id, taken) {
  var candidate = id;
  for (var n = 2; taken(candidate); n++) {
    candidate = id + "-" + n;
  }
  return candidate;
}

/**
 * "Create with AI" for a list screen: opens the prompt dialog, saves the
 * generated document in the browser through the collection's local store
 * and opens it. Shows only with ENABLE_AI_AUTHORING and the create permission.
 */
function AiCreateButton(_ref) {
  var kind = _ref.kind,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _ref2 = (0, _react.useContext)(_Translator.TranslatorContext) || {},
    _ref2$translate = _ref2.translate,
    translate = _ref2$translate === void 0 ? function (id, fallback) {
      return fallback;
    } : _ref2$translate;
  var collection = (0, _react.useContext)(KINDS[kind].context) || {};
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useState = (0, _react.useState)(false),
    open = _useState[0],
    setOpen = _useState[1];
  var onResult = function onResult(document) {
    var taken = function taken(id) {
      return Boolean(collection.isLocal && collection.isLocal(id) || collection.optimisticRead && collection.optimisticRead(id));
    };
    var saved = collection.saveLocal(Object.assign({}, document, {
      id: uniqueId(document.id, taken)
    }));
    navigate((0, _System.getScreenURL)(KINDS[kind].screen, saved));
  };
  return /*#__PURE__*/_react["default"].createElement(_HasAccess.HasAccess, {
    permission: KINDS[kind].permission,
    featureFlag: _featureFlags.ENABLE_AI_AUTHORING
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
    icon: _icons.IconNames.CLEAN,
    intent: _core.Intent.PRIMARY,
    onClick: function onClick() {
      return setOpen(true);
    },
    "data-testid": "AiCreateButton." + kind,
    text: translate("AiAuthoring.createButton", "Create with AI")
  }, extra)), /*#__PURE__*/_react["default"].createElement(_AiPromptDialog.AiPromptDialog, {
    kind: kind,
    mode: "create",
    isOpen: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    onResult: onResult
  }));
}